import { z, isoZ } from 'my-zod'
import { v4 as uuid } from 'uuid'

export const ServiceBulletinTypeEnum = z.enum(['ServiceBulletin', 'QualityHold', 'SafetyRecall']).setEnumLabels({
  ServiceBulletin: 'Service Bulletin',
  QualityHold: 'Quality Hold',
  SafetyRecall: 'Safety Recall'
})

export type ServiceBulletinTypeEnum = z.infer<typeof ServiceBulletinTypeEnum>

export const ServiceBulletinTypeValueOptions = Object.values(ServiceBulletinTypeEnum.Values).map((v) => ({
  value: v,
  label: ServiceBulletinTypeEnum.enumLabels[v]
}))

export const ServiceBulletinVehicleImpactTypeEnum = z.enum(['stopRide', 'requireInspection', 'continueRide']).setEnumLabels({
  stopRide: 'Stop Ride',
  requireInspection: 'Require Inspection',
  continueRide: 'Continue Ride'
})
export type ServiceBulletinVehicleImpactTypeEnum = z.infer<typeof ServiceBulletinVehicleImpactTypeEnum>

export const ServiceBulletinLifecycleStatus = z.enum(['Published', 'Unpublished'])
export type ServiceBulletinLifecycleStatus = z.infer<typeof ServiceBulletinLifecycleStatus>

export const serviceBulletinVehicleAssociationState = z.enum(['Open', 'Closed'])
export type serviceBulletinVehicleAssociationState = z.infer<typeof serviceBulletinVehicleAssociationState>

export const serviceBulletinVehicleAssociationClosingReason = z.enum(['Manual', 'Automatic'])
export type serviceBulletinVehicleAssociationClosingReason = z.infer<typeof serviceBulletinVehicleAssociationClosingReason>

export const serviceBulletinVehicleAssociation = z.object({
  bulletinId: z.string(),
  vehicleId: z.number(),
  notes: z.string().nullable(),
  state: serviceBulletinVehicleAssociationState.nullable(),
  lastUserId: z.number().nullable(),
  closingReason: serviceBulletinVehicleAssociationClosingReason.nullable(),
  closedDate: isoZ.instant().nullable(),
  createdDate: isoZ.instant().nullable(),
  lastModifiedDate: isoZ.instant().nullable(),
  deletedDate: isoZ.instant().nullable()
})
export type serviceBulletinVehicleAssociation = z.infer<typeof serviceBulletinVehicleAssociation>

export const serviceBulletinsModel = z.object({
  id: z
    .string()
    .uuid()
    .initFn(() => uuid()),
  shortId: z.string().nullable(),
  polarisId: z.string().nullable(),
  subject: z.string().nullable(),
  type: ServiceBulletinTypeEnum.nullable(),
  stopRide: z.boolean(),
  lifecycleStatus: ServiceBulletinLifecycleStatus.initFn(() => ServiceBulletinLifecycleStatus.Values.Unpublished),
  vehicleImpactType: ServiceBulletinVehicleImpactTypeEnum.initFn(
    () => ServiceBulletinVehicleImpactTypeEnum.Values.continueRide
  ),
  pdfUrl: z.string().nullable(),
  releaseDate: isoZ.date().nullable(),
  createdDate: isoZ.instant().nullable(),
  lastModifiedDate: isoZ.instant().nullable(),
  deletedDate: isoZ.instant().nullable(),
  wasAutoCreated: z.boolean(),
  vehicleAssociations: serviceBulletinVehicleAssociation.array()
})

export type serviceBulletinsModel = z.infer<typeof serviceBulletinsModel>

export const SafetyRecallApiServiceBulletinView = z.object({
  bulletinNumber: z.string(),
  description: z.string(),
  typeCode: z.string(),
  activeDate: z.string(), // Example: "activeDate": "2022-07-01"
  expirationDate: z.string().optional(),
  nhtsaCode: z.string().optional(),
  nhtsaRecallDescription: z.string().optional(),
  safetyRiskDescription: z.string().optional(),
  remedyDescription: z.string().optional(),
  nhtsaNotifiedDate: z.string().optional(),
  isStopSale: z.boolean(),
  status: z.string(),
  completionDateTime: z.string().optional(),
  isOpen: z.boolean().optional(),
  isDeclined: z.boolean().optional(),
  declinedReasonCode: z.string().optional(),
  bulletinURI: z.string().optional()
})

export type SafetyRecallApiServiceBulletinView = z.infer<typeof SafetyRecallApiServiceBulletinView>
